$(document).ready(function(){

	// -- init Isotope --
	var $grid = $('.grid').isotope({
		itemSelector: '.grid-item',
		percentPosition: true,
		layoutMode: 'fitRows',
	});

	// -- layout Isotope after each image loads --
	$grid.imagesLoaded().progress( function() {
	  $grid.isotope('layout');
	});

	// -- filter by cats --
	$('.filters__btn').on('click', function(){
		// -- scroll to grid --
		$('html, body').animate({
			scrollTop: $('#article__list').offset().top - $('.header__navbar').outerHeight() - $('.filters').outerHeight(true)
		}, 'slow');

		// -- filter --
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$grid.isotope({ filter: '*' });
		} else {
			$('.filters__btn').removeClass('active');
			$(this).addClass('active');
			var activeFilter = $(this).data('filter');
			$grid.isotope({ filter: activeFilter });
		}
	});

});